module.exports = __webpack_public_path__ + "img/stethoscope.48edd696.svg";